var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"percentage-bar"},[_c('Bar',{attrs:{"percentage":_vm.value,"primary-color":_vm.primaryColor,"slices":_vm.slices}}),_vm._v(" "),(_vm.showPercentage)?_c('span',{staticClass:"ml-5 percentage-value"},[_vm._v(_vm._s(_vm.formattedPercentage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }